import React, { useState, useEffect, useRef } from 'react'
import {useParams} from 'react-router-dom';
import './searchObject.scss'
import AIPanel from "../../../components/AIChat/AIPanel";
import { useConvokeDomainContext } from '../ConvokeDomainProvider';
import {TableControl} from 'spark-core-dx/components';
import {useCoreRoute} from 'spark-core-dx/hooks'

const SearchSourceObject = ({ }) => {

    const [data, setData] = useState(null);
    const [fieldOverrides, setFieldOverrides] = useState(null);
    const {coreNavigate} = useCoreRoute();
    const {sourceObjectMgr, loadingState } = useConvokeDomainContext();
    const {soId} = useParams();
    const pageRef = useRef(null);
    const [initialSearch,setInitialSearch] = useState(false);

        useEffect(() => {
            if (!data && sourceObjectMgr?.uiMetadata && !initialSearch) {
                setInitialSearch(true);
                const metadata = sourceObjectMgr?.uiMetadata?.length == undefined ? sourceObjectMgr?.uiMetadata : sourceObjectMgr?.uiMetadata?.first();
                let take = metadata?.ProfilePreferences?.HasPaging ? metadata?.ProfilePreferences?.HasPaging.first() : metadata?.HasPaging ? metadata?.HasPaging.first() : 50000;
                const isServerSide = metadata?.ProfilePreferences?.ServerFilterSort !== undefined && metadata?.ProfilePreferences?.ServerFilterSort !== null   ? 
                                     metadata?.ProfilePreferences?.ServerFilterSort : metadata?.ServerFilterSort;
                if(isServerSide === false)
                    sourceObjectMgr?.search({id:soId,queryParams:{search:true}, take: (take ?? 50000),forceUpdate:true });
            }
            else if (sourceObjectMgr && !sourceObjectMgr?.uiMetadata){
                
                sourceObjectMgr?.LoadMetadata();
            }
        },[sourceObjectMgr?.uiMetadata])
    

    useEffect(() => {
        if (!loadingState && sourceObjectMgr) {
            setData(sourceObjectMgr?.filteredData)
        }
    }, [loadingState, sourceObjectMgr?.filteredData])

    const onServerSideQuery = async (itemQuery) => {
       const result = await sourceObjectMgr.search({id:soId,queryParams:{search:true}, searchModel: itemQuery, forceUpdate: true })
       return result;
    }

    const onUpdatePanel = async (UICommand, item, value)=>{
        if(UICommand === "filter"){
              const selectColumns = item?.SelectColumns
              const deepCopy = v => typeof structuredClone === "function" ? structuredClone(v) : JSON.parse(JSON.stringify(v)); // fallback
                if (selectColumns && selectColumns.length > 0 && sourceObjectMgr?.uiMetadata && sourceObjectMgr?.uiMetadata?.length>0) {
                    const allowed = new Set(selectColumns.map(s => s.toLowerCase()));
                    let fieldToOverride = sourceObjectMgr?.uiMetadata.first().Fields.map(deepCopy);
                    // Flip ShowOnGrid on the copies only
                    fieldToOverride = fieldToOverride.map(f => {
                        const name = (f?.FieldName ?? "").toString().toLowerCase();
                        if (!allowed.has(name)) {
                            f.ShowOnGrid = false;
                            f.IsActive = false;
                            f.IsDeleted = true;
                        }
                        return f;
                    });

                    setFieldOverrides(fieldToOverride);
                }

            await sourceObjectMgr.search({id:item.SourceObjectId, searchModel: item,queryParams:{search:true}, forceUpdate: true })   
        }
    }
    
    const onLoadRow = async (rowId) => {
        const item = await sourceObjectMgr.getItem(rowId).then((r) => {
            if (r.Success) {
                return r.Items.first()
            }
        })
        const newData = data.map(i => i._id === item._id ? item : i)
        setData(newData)
        return item
    }

    return ( <>
                    {sourceObjectMgr?.uiMetadata?.AISupportsSession || true ?
            		<AIPanel
						childrenRef={pageRef}
						open={true}
						onUpdatePanel={onUpdatePanel}
						mapToClass={'core-layout'}
                        params={{}}
						referenceId={soId}
						referenceName={"object"}
                        operationName = {"AIQuestionSourceObject"}
						onCancel={()=>{coreNavigate("/dynamic/sourceobject/")}}
                        >
                            <div className="ai-panel__table">
                                <TableControl
                                    data={data}
                                    className={"search-object-table"}
                                    enableMultiSelect={false}
                                    defaultNumRows={50}
                                    onServerSideQuery={onServerSideQuery}
                                    metadata={sourceObjectMgr?.uiMetadata}
                                    loadingState={loadingState}
                                    filters={sourceObjectMgr?.filters}
                                    mgr={sourceObjectMgr}
                                    fieldOverrides = {fieldOverrides}
                                    enableSidePanelEdit={true}
                                    onLoadRow={onLoadRow}
                                />
                            </div>
					</AIPanel> :
                     <TableControl
                                data={data}
                                className={"search-object-table"}
                                enableMultiSelect={false}
                                fieldOverrides = {fieldOverrides}
                                defaultNumRows={50}
                                onServerSideQuery={onServerSideQuery}
                                metadata={sourceObjectMgr?.uiMetadata}
                                loadingState={loadingState}
                                filters={sourceObjectMgr?.filters}
                                mgr={sourceObjectMgr}
                                enableSidePanelEdit={true}
                            />}
           
        </>
    );
}

export default SearchSourceObject;



